/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScheduledChangeWorkingModeDetail } from './scheduledChangeWorkingModeDetail';

export type ScheduledChangeDetailWorkingMode = ScheduledChangeWorkingModeDetail | null;
